export const isMacOS = () => {
  const userAgent = global.navigator?.userAgent

  if (!userAgent) {
    return false
  }

  const isMac = userAgent.toLowerCase().includes('mac os x')

  return isMac
}

const SHORTCUT_SYMBOLS = {
  macCmd: '⌘',
  Ctrl: 'Ctrl',
}
/** Formate la description d'un raccourci clavier comme suit :
 *    $CTRL est remplacé par 'Cmd' sur Mac ou 'Ctrl' sinon
 */
export const platformShortCutLabel = (input: string) => {
  const ctrlLabel = isMacOS() ? SHORTCUT_SYMBOLS.macCmd : SHORTCUT_SYMBOLS.Ctrl
  const formated = input.replaceAll('$CTRL', ctrlLabel)
  return formated
}
